import { selectPostJobStep, selectPostedJobs, selectPostingNewJob } from '../../../../../store/workspace/selectors'
import { setExamShareGuideModal, setPostJobStep, setSubmittingJobModal } from '../../../../../store/workspace/slice';
import { useDispatch, useSelector } from '../../../../../store/store';
import { FileUploadIcon, FileUploadSuccessIcon } from '../../../../../assets/icons';
import Modal from '../../../../../components/Modal';
import styles from './style.module.scss';
import Spinner from '../../../../../components/Spinner';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function SubmittingJob() {
    const dispatch = useDispatch();
    const posting = useSelector(selectPostingNewJob);
    const [countdown, setCountdown] = useState(5);
    const step = useSelector(selectPostJobStep);
    const navigate = useNavigate();
    const postedJobs = useSelector(selectPostedJobs);

    useEffect(() => {
        if (step === 'Approval') {
            const interval = setInterval(() => {
                setCountdown(prev => prev - 1);
            }, 1000);
            return () => clearInterval(interval);
        }
    }, [step]);

    useEffect(() => {
        if (countdown === 0) {
            dispatch(setSubmittingJobModal(false));

            if (postedJobs.length === 0) {
                dispatch(setExamShareGuideModal(true));
            }

            navigate('/workspace?tab=Unposted');
            dispatch(setPostJobStep('JobDetail'));
        }
    }, [countdown]);

    return (
        <Modal
            size='md'
            childClassName={styles.wrapper}
        >
            {posting && <>
                <FileUploadIcon />
                <Spinner />
                <h3>Processing and saving job post</h3>
                <span>The process might take a few minutes, so please be patient</span>
            </>}

            {step === 'Approval' && !posting && <>
                <FileUploadSuccessIcon />
                <h3>Job posted successfully.</h3>
                <span>Navigating to dashboard in <b>{countdown}</b> seconds</span>
            </>}
        </Modal>
    )
}
